var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{attrs:{"bordered":false}},[_c('a-tabs',{attrs:{"default-active-key":"1"},on:{"change":_vm.callback}},[_c('a-tab-pane',{key:"1",attrs:{"tab":_vm.$t('待办')}},[_c('Unprocessed')],1),_c('a-tab-pane',{key:"2",attrs:{"tab":_vm.$t('已办'),"force-render":""}},[_c('Completed')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }